import styled from "styled-components";
import Responsive from "./media-queries";
import { Link } from "gatsby";

const LinkButton = styled(Link)`
  background: ${(props) => props.theme.colours.tertiary};
  color: ${(props) => props.theme.colours.darkGrey};
  display: block;
  font-family: ${(props) => props.theme.typography.body.font};
  font-size: 1.2rem;
  font-weight: 700;
  height: 3rem;
  line-height: 3rem;
  overflow: hidden;
  text-align: center;
  transition: all 250ms ease;
  width: 100%;

  &:hover {
    background: ${(props) => props.theme.colours.tertiaryHover};
    color: ${(props) => props.theme.colours.darkGrey};
  }

  ${Responsive.lg} {
    display: none;
  }
`;

export const DonateBar = () => {
  return (
    <LinkButton title="Donate" to="/donate">
      Donate
    </LinkButton>
  );
};
